import type {
  AllCaughtUpTemplate,
  InGameQuestTemplate,
  SelectGenreTemplate,
  SelectQuestDifficultyTemplate,
  SignInTemplate,
  SocialConnectionTemplate,
} from "@/domain/gems-game/domain";
import { DiscordLinkedAccountPlatform } from "@/utils/linkedaccounts/discord";
import { XLinkedAccountPlatform } from "@/utils/linkedaccounts/x";
import { Box } from "@mui/material";

export const DiscordConnectionItem: SocialConnectionTemplate = {
  type: "socialconnection",
  id: "discord-connection",
  quest: {
    questId: "discord-connection",
    gemsEarnable: 50,
  },
  platform: DiscordLinkedAccountPlatform,
  priority: 21,
  bypass: false,
  categories: ["social"],
  tags: ["discord", "social", "connect"],
  createdAt: new Date("2025-05-21"),
};

export const XConnectionItem: SocialConnectionTemplate = {
  type: "socialconnection",
  id: "x-connection",
  quest: {
    questId: "x-connection",
    gemsEarnable: 50,
  },
  platform: XLinkedAccountPlatform,
  priority: 20,
  bypass: false,
  categories: ["social"],
  tags: ["x", "social", "connect"],
  createdAt: new Date("2025-05-21"),
};

export const allCaughtUpCard: AllCaughtUpTemplate = {
  id: "all-caught-up-static",
  type: "allcaughtup",
  priority: 999,
  bypass: false,
  categories: ["system"],
  tags: ["system"],
  quest: {
    questId: "all-caught-up-static",
    gemsEarnable: 0,
  },
};

export const getSignInItem = (): SignInTemplate => ({
  type: "signin",
  id: "signin",
  quest: { questId: "signin", gemsEarnable: 0 },
  priority: 0,
  bypass: false,
  categories: ["signin"],
  tags: ["signin"],
  createdAt: new Date("2025-05-28"),
});

export const getSelectGenreItem = (): SelectGenreTemplate => ({
  type: "selectgenre",
  id: "select-genre",
  quest: {
    questId: "11111111-1111-1111-1111-111111111111-select-player-genre-event",
    gemsEarnable: 5,
  },
  priority: 1,
  bypass: false,
  categories: ["immutable"],
  tags: ["genre", "selection", "onboarding"],
  createdAt: new Date("2025-08-20"),
});

export const getSelectQuestDifficultyItem =
  (): SelectQuestDifficultyTemplate => ({
    type: "selectquestdifficulty",
    id: "select-quest-difficulty",
    quest: {
      questId: "select-quest-difficulty",
      gemsEarnable: 0,
    },
    priority: 2,
    bypass: false,
    categories: ["immutable"],
    tags: ["quest-difficulty", "user-preference", "selection", "onboarding"],
    createdAt: new Date("2025-08-20"),
  });

export const getBattleriseInGameQuestItem = (): InGameQuestTemplate => ({
  type: "ingamequest",
  id: "battlerise-in-game-quest",
  quest: {
    questId: "b6cc4d07-31af-4702-b011-ff231d738b4e-download-game-event",
    gemsEarnable: 20,
  },
  priority: 3,
  bypass: false,
  categories: ["immutable"],
  tags: ["ingamequest", "onboarding"],
  controlTags: ["difficulty:medium"],
  createdAt: new Date("2025-08-25"),
  game: {
    id: "battlerise",
    name: "Battlerise",
  },
  title: "Download & Play BattleRise. Get 20 Gems",
  description:
    "In BattleRise, wield mighty artifacts, and strategize for epic PvP battles. Complete this quest to earn gems toward Immutable’s rewards pool woth $60 each week!",
  backgroundImage: "/images/discover/in-game-quest-battlerise.webp",
  buttonLabel: "Download BattleRise",
  buttonURL:
    "https://store.ultra.io/en/store/games/armourx/68107071e2d476adf32cfa8f",
  infoItems: ["Download & Play BattleRise", "Quest time: 5 minutes"],
});

export const getGOGInGameQuestItem = (): InGameQuestTemplate => ({
  type: "ingamequest",
  id: "gog-in-game-quest",
  quest: {
    questId:
      "8bbf049c-5ffb-4e1a-8e28-086397627dde-gog-adventure-daily-completed",
    gemsEarnable: 10,
  },
  priority: 3,
  bypass: false,
  categories: ["immutable"],
  tags: ["ingamequest", "onboarding"],
  controlTags: ["difficulty:hard"],
  createdAt: new Date("2025-08-25"),
  game: {
    id: "guild-of-guardians",
    name: "Guild of Guardians",
  },
  title: "Play Guild of Guardians",
  description:
    "Your next step to claim free entry and earn from a $60k rewards pool! You got this!",
  backgroundImage: "/images/discover/in-game-quest-gog.webp",
  buttonLabel: "Play now",
  buttonURL: "https://www.gog.com/game/guild_of_guardians",
  infoItems: [
    "Download Guild of Guardians",
    "Use 9 Adventure Energy",
    "Quest time: 1 hour",
  ],
});

export const ContentContainer = ({
  children,
}: { children: React.ReactNode }) => {
  return (
    <Box
      style={{
        height: "100%",
        scrollSnapAlign: "start",
        position: "relative",
        scrollSnapStop: "always",
        scrollBehavior: "smooth",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {children}
    </Box>
  );
};

export function detectUserAgent(
  userAgent: string,
): "iOS" | "Android" | "General" {
  if (/android/i.test(userAgent)) {
    return "Android";
  }
  if (/iPad|iPhone|iPod|Macintosh|Mac OS X/i.test(userAgent)) {
    return "iOS";
  }
  return "General";
}
